<h3-feedback-item
  [title]="highlightFeedback.errorTag"
  [subTitle]="getSubtitle()"
  [isEditAllowed]="isEditAllowed$ | async"
  [isDeleteAllowed]="isDeleteAllowed"
  [timestamp]="highlightFeedback.updatedAt"
  [comment]="highlightFeedback.comment"
  [selected]="isSelected$ | async"
  (edit)="editFeedback()"
  (delete)="deleteFeedback()"
  (select)="selectFeedback()"
></h3-feedback-item>
